import React, { useState,useEffect } from "react";


const FloatingSupportMenu = () => {
  const [open, setOpen] = useState(false);

  const openTawk = () => {
    if (window.Tawk_API) {
      window.Tawk_API.maximize();
    }
  };
  useEffect(() => {
  const style = document.createElement("style");
  style.innerHTML = `
    iframe[title="chat widget"] {
      display: none !important;
    }
  `;
  document.head.appendChild(style);
}, []);
useEffect(() => {
  const hideTawk = () => {
    if (window.Tawk_API && window.Tawk_API.hideWidget) {
      window.Tawk_API.hideWidget();
    }
  };

  // Wait a little in case script loads late
  const timer = setTimeout(hideTawk, 1000);

  return () => clearTimeout(timer);
}, []);
  return (
    <div style={styles.container}>
      {open && (
        <div style={styles.menu}>
          {/* WhatsApp */}
          <a
            href="https://wa.me/918951990373"
            target="_blank"
            rel="noopener noreferrer"
            style={{ ...styles.button, backgroundColor: "#25D366" }}
          >
            🟢 WhatsApp
          </a>

          {/* Tawk Chat */}
          <button
            onClick={openTawk}
            style={{ ...styles.button, backgroundColor: "#007bff" }}
          >
            💬 Live Chat
          </button>
        </div>
      )}

      {/* Main Toggle Button */}
      <button
        onClick={() => setOpen(!open)}
        style={styles.mainButton}
      >
        {open ? "✕" : "Support"}
      </button>
    </div>
  );
};

const styles = {
  container: {
    position: "fixed",
    bottom: "20px",
    right: "20px",
    zIndex: 9999,
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-end",
  },
  menu: {
    marginBottom: "10px",
    display: "flex",
    flexDirection: "column",
    gap: "10px",
  },
  button: {
    border: "none",
    color: "#fff",
    padding: "10px 16px",
    borderRadius: "50px",
    cursor: "pointer",
    fontWeight: "bold",
    boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
  },
  mainButton: {
    backgroundColor: "#111",
    color: "#fff",
    border: "none",
    padding: "14px 20px",
    borderRadius: "50px",
    cursor: "pointer",
    fontWeight: "bold",
    boxShadow: "0 4px 15px rgba(0,0,0,0.3)",
  },
};

export default FloatingSupportMenu;
